import { UserPreferences } from "../model/UserPreferences";
import LocalStorage from "../infrastructure/storage/LocalStorage";
import deepmerge from "deepmerge";

export default class UserPreferencesStore {
    private state: UserPreferences;
    private storage: LocalStorage;

    constructor(storage: LocalStorage) {
        this.storage = storage;
        this.state = storage.getItem('preferences') || {};
    }

    readonly updateState = (state: Partial<UserPreferences>): void => {
        const overwriteMerge = (destinationArray: Array<any>, sourceArray: Array<any>) => sourceArray;
        this.state = deepmerge(this.state, state, { arrayMerge: overwriteMerge });
        this.storage.setItem('preferences', this.state);
    }

    readonly getState = (): UserPreferences => {
        return this.state;
    }
}


